import React, { useState , useEffect} from 'react';
import FalconComponentCard from 'components/common/FalconComponentCard';
import firebase from './../../../firebase';
import { useParams } from 'react-router-dom';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import IconButton from 'components/common/IconButton';
import Flex from 'components/common/Flex';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';



const FicheContact = () => {
    const { id } = useParams();
    const [validated, setValidated] = React.useState(false);
    const [formd, setFrom] = React.useState({});
    const [prep, setPrep] = React.useState(true);
    const [l, setL] = React.useState(false);
    const [services, setServices] = React.useState([]);

    const [contacts, setContact] = React.useState([]); 

    const getPropertie = (fhsId) => {
        fetch(`https://us-central1-fabiohome-1.cloudfunctions.net/httpsApp/property`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
           body: JSON.stringify({id: fhsId }),
      }).then((res) => res.json())
          .then((data) => {
            console.log('data', data);
            if (data) {
                setContact(data?.contacts)
            }
            // if (data?.success){
            //   // console.log('properties',data.properties);   
              
            //   data.properties?.forEach((dp) => {
            //      prep(dp, ( (sd) => {
            //       console.log("sd", sd)
            //       createPropertie(sd);
            //     }));
            //   })
    
    
            // }
          }).catch(err => console.error('error', err))
      }




      useEffect(() => {
        if (id) {
            firebase.firestore().collection('properties').doc(id).get().then(doc => {
                if (doc) {
                    let d = doc.data()
                    d.id = doc.id;
                    setFrom(d)
                    setServices(d?.contacts || []);
                    setPrep(false) 
                    if (d?.fhsId){ getPropertie(d?.fhsId)
                    }
                }
            })
        } else {
            toast.error('Une erreur s\'est produite.');
        }
    }, []);


    const handleSubmit = (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();

        // console.log(formd)
        if (form.checkValidity() === false) {
            toast.warning("Veuillez remplir les champs obligatoire")
            return;
        }

        if (l) {
            return;
        }

        var t = { ...formd }
        t._update_At = new Date();


        setValidated(true);
        setL(true);  
        try {
            firebase.firestore().collection('properties').doc(id).update({_update_At: new Date(), contacts:formd?.maison  }).then(() => {
                console.log("Document successfully written!");
                toast.success("Fiche contact modifiée avec succès");
                setL(false);
            }).catch((error) => {
                setL(false);
                var errorMessage = error.message;
                toast.error(errorMessage);
            })
        } catch (error) {
            setL(false);
            var errorMessage = error.message;
            toast.error(errorMessage);
        }
    };


    const contactsS = contacts.sort((a, b) => a.order - b.order);





    return (
        <FalconComponentCard>
            {
                prep ? <p style={{ margin: 10 }}>Chargement ....</p> : (<>


                    <FalconComponentCard.Header title={`Fiche contact - ${formd.nameHouse}`} light={false} noPreview={true} />
                    <Col xs="auto" style={{ padding: 20 }}>
                        <IconButton href={`/villa/edit/${id}`}
                            variant="falcon-secondary"
                            size="sm"
                            transform="shrink-3"
                            className='me-2'
                        >Retourner à la page de modification</IconButton>
                        <IconButton href={`/villa/edit/${id}/fichemaison`}
                                        variant="falcon-primary"
                                        size="sm"
                                        icon="home"
                                        transform="shrink-3"
                                        className='me-2'
                                        >Fiche maison</IconButton>
                        <IconButton target="_blank" href={`/v/${id}`}
                            variant="falcon-primary"
                            size="sm"
                            icon="eye"
                            transform="shrink-3"
                            className='me-2'
                        >Voir la fiche descriptive</IconButton>
                    </Col>
                    <FalconComponentCard.Body >

                    {contactsS.length> 0 && (
                            <div>
                            <h1 className="text-center mb-4">Données de FABIO HOME SERVICES</h1>
                            
                            <div className="table-responsive">
                              <table className="table table-bordered table-hover">
                                <thead className="thead-dark">
                                  <tr>
                                    <th scope="col">Nom</th>
                                    <th scope="col">Téléphone</th>
                                    <th scope="col">Email</th>
                                    <th scope="col">Informations</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {contactsS.map((sheet, index) => (
                                    <tr key={index}>
                                      <td>{sheet.displayName}</td>
                                      <td>{sheet.phone || 'N/A'}</td>
                                      <td>{sheet.email || 'N/A'}</td>
                                      <td>{sheet.info || 'N/A'}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        )}
                        <Form noValidate validated={validated} onSubmit={handleSubmit}>
                            <Row className="mb-3">
                                <Form.Label>Vos informations des prestataires lié a la propriété.</Form.Label>
                                {
                                    services?.map((service, index) => {
                                        return (<Row className="mb-3">



                                            <Form.Group as={Col} md="2" className="mb-3">
                                                <Form.Label>Titre</Form.Label>
                                                <Form.Control
                                                    name={`serviceTitle_${index}`}
                                                    placeholder="Titre"
                                                    value={service.title}
                                                    onChange={(e) => {
                                                        let o = [...services];
                                                        let m = { ...service };
                                                        m.title = e.target.value
                                                        o[index] = m;
                                                        setServices(o);
                                                        let d = { ...formd };
                                                        d['maison'] = o;
                                                        setFrom(d);
                                                    }}
                                                />
                                            </Form.Group>

                                            <Form.Group as={Col} md="3" controlId="information">
                                                <Form.Label>Information</Form.Label>
                                                <Form.Control 
                                                    as="textarea" 
                                                    rows={1}  
                                                    value={service?.information}
                                                    name={`serviceDescription_${index}`}
                                                    placeholder="Écrivez votre information ici..." 
                                                    onChange={(e) => {
                                                        let o = [...services];
                                                        let m = { ...service };
                                                        m.information = e.target.value
                                                        o[index] = m;
                                                        setServices(o);
                                                        let d = { ...formd };
                                                        d['maison'] = o;
                                                        setFrom(d);
                                                    }}
                                                /> 
                                            </Form.Group>

                                            <Form.Group as={Col} md="2" controlId="email">
                                                <Form.Label>Email</Form.Label>
                                                <Form.Control
                                                    type="email"
                                                    value={service?.email}
                                                    name={`serviceEmail_${index}`}
                                                    onChange={(e) => {
                                                        let o = [...services];
                                                        let m = { ...service };
                                                        m.email = e.target.value
                                                        o[index] = m;
                                                        setServices(o);
                                                        let d = { ...formd };
                                                        d['maison'] = o;
                                                        setFrom(d);
                                                    }}
                                                    placeholder="Email..."
                                                />
                                            </Form.Group>

                                            <Form.Group as={Col} md="2" controlId="phone">
                                                <Form.Label>Téléphone</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    value={service?.phone}
                                                    name={`servicePhone_${index}`}
                                                    onChange={(e) => {
                                                        let o = [...services];
                                                        let m = { ...service };
                                                        m.phone = e.target.value
                                                        o[index] = m;
                                                        setServices(o);
                                                        let d = { ...formd };
                                                        d['maison'] = o;
                                                        setFrom(d);
                                                    }}
                                                    placeholder="Téléphone..."
                                                />
                                            </Form.Group>



                                            <IconButton as={Col} md="1" onClick={() => {
                                                let arr = services;
                                                arr.splice(index, 1);
                                                setServices(arr);
                                                let d = { ...formd };
                                                d['maison'] = arr;
                                                setFrom(d);
                                            }}
                                                variant="falcon-danger"
                                                size="sm"
                                                icon="trash"
                                                transform="shrink-3"
                                                className='me-2'
                                                style={{ width: 60, height: 25, marginTop: 35 }}
                                            >
                                            </IconButton>
                                        </Row>)
                                    })
                                }

                                <div>
                                    <Flex
                                        alignItems="center"
                                        className="mb-4 text-primary cursor-pointer fs-0"
                                        onClick={() => {
                                            let o = [...services];
                                            if (o[o.length - 1]?.title?.trim() !== ""  ) {
                                                o.push({  title: "", information: "", phone: "", email: "" });
                                                setServices(o);
                                            }
                                        }}
                                    >
                                        <span className="circle-dashed">
                                            <FontAwesomeIcon icon="plus" />
                                        </span>
                                        <span className="ms-3">Ajouter une nouvelle information</span>
                                    </Flex>
                                </div>
                            </Row>

                            <Button type="submit" disabled={l}>{l ? 'Chargement' : 'Modifier'}</Button>
                        </Form>
                    </FalconComponentCard.Body>


                </>)
            }
        </FalconComponentCard>
    );
};

export default FicheContact;
